import { createSlice } from "@reduxjs/toolkit";

interface ProfileContextState {
	isProfileContextModalVisible: boolean;
}

const initialState: ProfileContextState = {
	isProfileContextModalVisible: false,
};

const profileContextSlice = createSlice({
	name: "profileContext",
	initialState,
	reducers: {
		setIsProfileContextModalVisible: (state, action) => {
			state.isProfileContextModalVisible = action.payload;
		},
	},
});

export const { setIsProfileContextModalVisible } = profileContextSlice.actions;

export default profileContextSlice.reducer;
